<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id" />
      </a-form-model-item>
      <a-form-model-item label="心率最大值(次/分)" prop="maxNum" >
        <a-input v-model="form.maxNum" placeholder="请输入心率最大值(次/分)" />
      </a-form-model-item>
      <a-form-model-item label="心率最小值(次/分)" prop="minNum" >
        <a-input v-model="form.minNum" placeholder="请输入心率最小值(次/分)" />
      </a-form-model-item>
      <a-form-model-item label="心率平均值(次/分)" prop="averageNum" >
        <a-input v-model="form.averageNum" placeholder="请输入心率平均值(次/分)" />
      </a-form-model-item>
      <a-form-model-item label="极限区(min)" prop="extremeZone" >
        <a-input v-model="form.extremeZone" placeholder="请输入极限区(min)" />
      </a-form-model-item>
      <a-form-model-item label="有氧耐力(min)" prop="aerobicEndurance" >
        <a-input v-model="form.aerobicEndurance" placeholder="请输入有氧耐力(min)" />
      </a-form-model-item>
      <a-form-model-item label="无氧耐力(min)" prop="anaerobicEndurance" >
        <a-input v-model="form.anaerobicEndurance" placeholder="请输入无氧耐力(min)" />
      </a-form-model-item>
      <a-form-model-item label="燃脂区(min)" prop="burningGrease" >
        <a-input v-model="form.burningGrease" placeholder="请输入燃脂区(min)" />
      </a-form-model-item>
      <a-form-model-item label="热身区(min)" prop="warmUp" >
        <a-input v-model="form.warmUp" placeholder="请输入热身区(min)" />
      </a-form-model-item>
      <a-form-model-item label="安静区(min)" prop="beQuiet" >
        <a-input v-model="form.beQuiet" placeholder="请输入安静区(min)" />
      </a-form-model-item>
      <a-form-model-item label="结果类型 0-静息 1-热身 2-燃脂 3-心肺耐力 4-极限" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="是否报警" prop="isCallPolice" >
        <a-input v-model="form.isCallPolice" placeholder="请输入是否报警" />
      </a-form-model-item>
      <a-form-model-item label="报警值" prop="callPoliceData" >
        <a-input v-model="form.callPoliceData" placeholder="请输入报警值" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHeartRecord, addHeartRecord, updateHeartRecord } from '@/api/joe/heartRecord'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        maxNum: null,

        minNum: null,

        averageNum: null,

        extremeZone: null,

        aerobicEndurance: null,

        anaerobicEndurance: null,

        burningGrease: null,

        warmUp: null,

        beQuiet: null,

        type: null,

        isCallPolice: null,

        callPoliceData: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        maxNum: null,
        minNum: null,
        averageNum: null,
        extremeZone: null,
        aerobicEndurance: null,
        anaerobicEndurance: null,
        burningGrease: null,
        warmUp: null,
        beQuiet: null,
        type: null,
        isCallPolice: null,
        callPoliceData: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHeartRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateHeartRecord(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addHeartRecord(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
